export const COMIC_PANEL_DRAG_MIME = 'application/x-glyphic-comic-panel-id'

export function setComicPanelDragData(dataTransfer: DataTransfer, panelId: string): void {
  dataTransfer.setData(COMIC_PANEL_DRAG_MIME, panelId)
  dataTransfer.effectAllowed = 'move'
}

export function readComicPanelDragId(dataTransfer: DataTransfer): string | null {
  const id = dataTransfer.getData(COMIC_PANEL_DRAG_MIME)
  return id || null
}
